import { useDispatch } from 'react-redux';
import { getSourceConfig } from './config';
import useLoadingState from 'shared/../hooks/useLoadingState';
import { setFileTypes } from 'src/slices/fileTypes';

const useStoreLoading = (source) => {
  const dispatch = useDispatch();

  const config = getSourceConfig(source);
  const { getDocumentTypes } = config;

  const documentTypesPromise = () => getDocumentTypes()
    .then((fileTypes) => dispatch(setFileTypes({ fileTypes, source })));

  const loadData = () => Promise.all([documentTypesPromise()]);

  const { status, error } = useLoadingState(loadData);
  return { status, error };
};

export default useStoreLoading;
